import {
  LayoutDashboard,
  Landmark,
  TrendingDown,
  Receipt,
  CalendarDays,
  BarChart3,
  PiggyBank,
  Tags,
  Target,
  RefreshCw,
  Users,
  Settings,
  type LucideIcon,
} from 'lucide-react'
import { SHARED_EXPENSES_ENABLED } from '@/lib/featureFlags'
import { ROUTES } from '@/routes/routes'

/** Where a section sits in the phone Menu sheet; the desktop sidebar lists them flat. */
export type NavGroup = 'Everyday' | 'Money' | 'Plan & insights' | 'Settings'

export interface NavItem {
  label: string
  to: string
  Icon: LucideIcon
  group: NavGroup
}

export const NAV_ITEMS: NavItem[] = [
  { label: 'Dashboard', to: ROUTES.APP.DASHBOARD, Icon: LayoutDashboard, group: 'Everyday' },
  { label: 'Analytics', to: ROUTES.APP.ANALYTICS, Icon: BarChart3, group: 'Plan & insights' },
  { label: 'Accounts', to: ROUTES.APP.ACCOUNTS, Icon: Landmark, group: 'Everyday' },
  { label: 'Loans', to: ROUTES.APP.LOANS, Icon: TrendingDown, group: 'Money' },
  { label: 'Transactions', to: ROUTES.APP.TRANSACTIONS, Icon: Receipt, group: 'Everyday' },
  { label: 'Calendar', to: ROUTES.APP.CALENDAR, Icon: CalendarDays, group: 'Plan & insights' },
  { label: 'Budget', to: ROUTES.APP.BUDGET, Icon: PiggyBank, group: 'Plan & insights' },
  { label: 'Categories', to: ROUTES.APP.CATEGORIES, Icon: Tags, group: 'Plan & insights' },
  { label: 'Goals', to: ROUTES.APP.GOALS, Icon: Target, group: 'Money' },
  { label: 'Recurring', to: ROUTES.APP.RECURRING, Icon: RefreshCw, group: 'Money' },
  ...(SHARED_EXPENSES_ENABLED
    ? [{ label: 'People', to: ROUTES.APP.PEOPLE, Icon: Users, group: 'Everyday' as const }]
    : []),
  { label: 'Settings', to: ROUTES.APP.SETTINGS, Icon: Settings, group: 'Settings' },
]

/** The sections that get their own tab on a phone; everything else is under Menu. */
export const TAB_ROUTES = [ROUTES.APP.DASHBOARD, ROUTES.APP.TRANSACTIONS, ROUTES.APP.ACCOUNTS]

/** The tab bar is 64px tall plus the home-indicator inset; bars pinned above it use this. */
export const ABOVE_TAB_BAR = 'bottom-[calc(64px+env(safe-area-inset-bottom))] lg:bottom-0'

/** Set on <body> while something (the bulk-select bar) takes over the bottom of the screen. */
export const HIDE_TAB_BAR_ATTR = 'data-hide-tab-bar'

export function isUnder(pathname: string, route: string): boolean {
  return pathname === route || pathname.startsWith(`${route}/`)
}
